import { Typeahead as BSTypeahead, ClearButton } from "react-bootstrap-typeahead";
import React, { useEffect, useRef, useState } from "react";
import {
  fetchCommandersTypeahead,
  fetchPartnersTypeahead,
  fetchTypeahead,
} from "../store/typeahead";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "../styles/Typeahead.module.scss";

const filterBy = (option, props) => format(option).startsWith(format(props.text));

const format = (str) =>
  str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(",", "")
    .replace("'", "")
    .replace("-", "")
    .toLowerCase();

const Typeahead = ({
  className,
  clearButton,
  clearOnChange,
  icon: inIcon,
  onChange,
  placeholder,
  selected,
  showLoading,
  type,
}) => {
  const dispatch = useDispatch();
  const ref = useRef();
  const {
    commandersTypeahead,
    isLoadingCommandersTypeahead,
    isLoadingPartnersTypeahead,
    isLoadingTypeahead: isLoadingDefaultTypeahead,
    partnersTypeahead,
    typeahead,
  } = useSelector((state) => state.typeahead);
  const { isLoading } = useSelector((state) => state.pagedata);
  const [icon, setIcon] = useState(inIcon || "search");

  useEffect(() => {
    if (
      type === "commanders" &&
      commandersTypeahead.length === 0 &&
      !isLoadingCommandersTypeahead
    ) {
      dispatch(fetchCommandersTypeahead());
    } else if (
      type === "partners" &&
      partnersTypeahead.length === 0 &&
      !isLoadingPartnersTypeahead
    ) {
      dispatch(fetchPartnersTypeahead());
    } else if (typeahead.length === 0 && !isLoadingDefaultTypeahead) {
      dispatch(fetchTypeahead());
    }
  }, [type]);

  const isLoadingTypeahead =
    type === "commanders"
      ? isLoadingCommandersTypeahead
      : type === "partners"
      ? isLoadingPartnersTypeahead
      : isLoadingDefaultTypeahead;

  useEffect(() => {
    if (isLoadingTypeahead || (showLoading && isLoading)) {
      setIcon("spinner");
    } else {
      setIcon(inIcon || "search");
    }
  }, [isLoading, isLoadingTypeahead]);

  const options =
    type === "commanders"
      ? commandersTypeahead
      : type === "partners"
      ? partnersTypeahead
      : typeahead;

  return (
    <BSTypeahead
      className={className}
      disabled={isLoadingTypeahead}
      filterBy={filterBy}
      id="searchbar"
      labelKey="label"
      minLength={3}
      onChange={(e) => {
        if (e.length > 0 && e[0].length > 0) {
          ref.current.blur();
        }
        if (clearOnChange) {
          ref.current.clear();
        }
        onChange(e);
      }}
      options={options}
      placeholder={placeholder}
      ref={ref}
      selected={selected}
    >
      {({ onClear, selected }) =>
        clearButton ? (
          <div className="rbt-aux">
            <ClearButton className={styles.icon} onClick={onClear} />
          </div>
        ) : (
          <div className="rbt-aux">
            <FontAwesomeIcon
              className={classNames(styles.icon, { "fa-spin": icon === "spinner" })}
              icon={icon}
            />
          </div>
        )
      }
    </BSTypeahead>
  );
};

Typeahead.propTypes = {
  className: PropTypes.string,
  clearButton: PropTypes.bool,
  clearOnChange: PropTypes.bool,
  icon: PropTypes.node,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  selected: PropTypes.arrayOf(PropTypes.string.isRequired),
  showLoading: PropTypes.bool,
  spinner: PropTypes.bool,
  type: PropTypes.string,
};

export default Typeahead;
